import React from "react";
import LineChats from "../graphs/LineChats";
import PieChats from "../graphs/PieChats";
import TableCustomVisuals from "../graphs/TableCustomVisuals";
import UserLableAnalytics from "../graphs/UserLableAnalytics";
import DatePickerFullTracking from "../graphs/DatePickerFullTracking";
import MultiBarChats from "../graphs/MultiBarChats";
import usePersonaManagement from "../hooks/usePersonaManagement";

const Analtyics = (props) => {
    const DataLoading = props.dataLoading
    const dataItems = props.jsonData
    const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))?.["accessToken"];
    const { getPersonaLabel } = usePersonaManagement(passtoken);
  return (
    <div style={{ display: "grid", gridGap: "3rem" }}>
      <div className="analytics_container">
        <div
          style={{
            boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
            height: "400px",
            padding: "1rem",
            borderRadius: "6px",
            width: "99%",
            paddingBottom: "2rem",
          }}
        >
          <LineChats dataLoading={DataLoading} jsonData={dataItems} />
        </div>

        <div
          style={{
            boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
            height: "400px",
            padding: "1rem",
            borderRadius: "6px",
            width: "99%",
            paddingBottom: "2rem",
            display: "grid",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <PieChats dataLoading={DataLoading} data={dataItems} />
        </div>

      

       

      </div>

      <div>
        <TableCustomVisuals dataLoading={DataLoading} data={dataItems} />
      </div>

      <div
          style={{
            boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
            height: "auto",
            padding: "1rem",
            borderRadius: "6px",
            width: "99%",
            paddingBottom: "1rem",
            paddingTop: "1rem",
            display: "grid",
            alignContent: "start",
            alignItems: "start",
          }}
        >
          <UserLableAnalytics getPersonaLabel={getPersonaLabel} />
        </div>

        <div  style={{
            boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
            height: "auto",
            padding: "1rem",
            borderRadius: "6px",
            width: "99%",
            paddingBottom: "1rem",
            paddingTop: "1rem",
            display: "grid",
            alignContent: "start",
            alignItems: "start",
          }}>
            <DatePickerFullTracking/>
        </div>

        {/* <div style={{
            boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
            height: "auto",
            padding: "1rem",
            borderRadius: "6px",
            width: "99%",
            paddingBottom: "1rem",
            paddingTop: "1rem",
            display: "grid",
            alignContent: "start",
            alignItems: "start",
          }}>
           <MultiBarChats/>
        </div> */}
    </div>
  
  );
};

export default Analtyics;
